import React, { Component } from 'react';

import Label from '~/components/shared/label';
import ValidationError from '~/components/shared/validation_error';

import { joinClasses } from '~/components/utils/react_helper';

class InputField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      focused: false,
    };
  }

  render() {
    const { label, prepend, append, errors, animatedPlaceholder, ...otherProps } = this.props;

    return (
      <label className="input-field">
        {label && <Label>{label}</Label>}

        <div className={this.innerClasses}>
          {animatedPlaceholder && <span className={this.animatedPlaceholderClasses}>{animatedPlaceholder}</span>}

          {prepend && <span className="input-field__prepend">{prepend}</span>}

          {this.renderInput(otherProps)}

          {append && <span className="input-field__append">{append}</span>}
        </div>

        <ValidationError version="2" errors={errors} />
      </label>
    );
  }

  renderInput = (otherProps) => {
    const { inputRef, ...remainingProps } = otherProps;
    const props = {
      className: this.inputClasses,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      ref: inputRef,
      ...remainingProps,
    };

    return this.props.type === 'textarea' ? <textarea {...props} /> : <input {...props} />;
  };

  onFocus = () => {
    this.setState({ focused: true });
  };

  onBlur = () => {
    this.setState({ focused: false });
  };

  get innerClasses() {
    return joinClasses([
      'input-field__inner',
      this.props.animatedPlaceholder && 'input-field__inner--has-placeholder',
      this.anyErrors && 'input-field__inner--validation-error',
    ]);
  }

  get animatedPlaceholderClasses() {
    return joinClasses([
      'input-field__placeholder',
      this.isAnimatedPlaceholderFocused && 'input-field__placeholder--focused',
    ]);
  }

  get inputClasses() {
    return joinClasses(['input-field__input', this.anyErrors && 'input-field__input--validation-error']);
  }

  get isAnimatedPlaceholderFocused() {
    return this.state.focused || this.props.value || this.props.prepend || this.props.placeholder;
  }

  get anyErrors() {
    return this.props.errors && this.props.errors.length > 0;
  }
}

export default InputField;
